module.exports = __webpack_public_path__ + "img/691.cf5a58e6.png";